import * as Yup from "yup"
import {
  cardExpiryDateRegExp,
  zipCodeRegex,
} from "../constants/cardDetailsValidation"
import {
  CARD_NUMBER_REQUIRED_VALIDATION,
  CARD_NUMBER_VALIDATION,
  CVV_VALIDATION,
  CVV_REQUIRED_VALIDATION,
  EXPIRY_DATE_REQUIRED,
  EXPIRY_DATE_VALIDATION,
  BILLING_ZIP_REQUIRED,
  FIRST_NAME_REQUIRED,
  LAST_NAME_REQUIRED,
  EMAIL_REQUIRED,
  BILLING_ZIP_MIN_MAX,
  INVALID_EXPIRY_DATE,
} from "../constants/messages"
import {
  emailNotLongEnough,
  invalidEmail,
  emailTooLong,
  minCharacters,
  maxCharacters,
  billingZipMinMax,
} from "../constants/validationMessages"
import { formatCreditCardNumber } from "../utils/cardUtils"
import valid from "card-validator" //import statement

export const CardDetailsValidation = Yup.object().shape({
  // Using this for card number validation https://github.com/braintree/card-validator
  cardNumber: Yup.string()
    .test(
      "card-number", // this is used internally by yup
      CARD_NUMBER_VALIDATION,
      value => valid.number(value).isValid // return true false based on validation
    )
    .required(CARD_NUMBER_REQUIRED_VALIDATION),
  CVV: Yup.string()
    .required(CVV_REQUIRED_VALIDATION)
    .min(3, CVV_VALIDATION)
    .max(4, CVV_VALIDATION),
  expiryDate: Yup.string()
    .required(EXPIRY_DATE_REQUIRED)
    .test(
      "expiry-date",
      INVALID_EXPIRY_DATE,
      value => valid.expirationDate(value).isValid
    )
    .matches(cardExpiryDateRegExp, EXPIRY_DATE_VALIDATION),
  billingZip: Yup.string()
    .test(
      "zipcode",
      BILLING_ZIP_MIN_MAX,
      value => valid.postalCode(value, { minLength: billingZipMinMax }).isValid
    )
    .required(BILLING_ZIP_REQUIRED)
    .matches(zipCodeRegex, BILLING_ZIP_MIN_MAX),
})

export const CheckPaymentDetailsValidation = Yup.object().shape({
  firstName: Yup.string()
    .required(FIRST_NAME_REQUIRED)
    .nullable(),
  lastName: Yup.string()
    .required(LAST_NAME_REQUIRED)
    .nullable(),
  paymentEmail: Yup.string()
    .min(minCharacters, emailNotLongEnough)
    .max(maxCharacters, emailTooLong)
    .email(invalidEmail)
    .required(EMAIL_REQUIRED)
    .nullable(),
})
